/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:456px}form[_ngcontent-%COMP%]{display:block;position:relative}h3[_ngcontent-%COMP%]{margin-bottom:24px}ui-checkbox[_ngcontent-%COMP%]{margin-top:18px}.actions[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row;justify-content:space-between;margin:32px 0 0}"];
export { styles as styles };
